import React,{useState,useEffect} from 'react';
import {Container, Row, Col,Button,Badge,Form } from "react-bootstrap";
import NavBar from "./NavBar";
import PuffLoader from "react-spinners/PuffLoader";
import "../layout/Main.css"; 
import Ban  from  "./asset/home.png";
import Collection1 from "./asset/backpackMan.png";
import Collection2 from "./asset/backpackWoman.png";
import {Database} from "./Firebase/Firebase";
import {Link} from "react-router-dom";
import useLocalStorage from "./LocaleStorage/UseLocaleStorage";
import AOS from "aos";
import "aos/dist/aos.css"
import Footer from './Footer';
const Main = () => {
    /** Icon Style */
    let iconStyles = { color: "#C5A207", fontWeight: "bold", fontSize: "1.5em" };
    const [articleViral,setArticleViral]=useState([]);
    const [loading,setLoading] = useState(false)
    const [articleWoman,setArticleWoman]=useState([]);
    const [articleWomanSabot,setArticleWomanSabot]=useState([]);
    const [articleLunettes,setArticleLunettes]=useState([]);
    const [subscribeed,setSubscribeed]=useState("")
    const [articleToSend,setArticleToSend]=useLocalStorage("Article")
    useEffect(()=>{
        setLoading(true);
        setTimeout(()=>{setLoading(false)},600)
        ReadDataFromDatabaseViral();
        ReadDataFromDatabaseWoman();
        ReadDataFromDatabaseSabot();
        ReadDataFromDatabaseLunettes();
        AOS.init({duration:600})
    },[])

    /*  Get Viral Article  */
    const ReadDataFromDatabaseViral = ()=>{
        const articleViral = Database.database().ref("ViralArticles")
        articleViral.on("value",(snapShot)=>{
          const data= snapShot.val();
          let  list = [];
            for( let id in data)
             {
               list.push({id,...data[id]})
             }
             setArticleViral(list)
        })
    }


    /*** Get Woman Article */
    const ReadDataFromDatabaseWoman = ()=>{
        const articleWoman = Database.database().ref("WomanArticles")
        articleWoman.on("value",(snapShot)=>{
          const data= snapShot.val();
          let  list = [];
            for( let id in data)
             {
               list.push({id,...data[id]})
             }
             setArticleWoman(list)
             
        })
    }


    /*** Get Sabot Articles */
    const ReadDataFromDatabaseSabot = ()=>{
        const articleSabot = Database.database().ref("WomanArticlesSabot")
        articleSabot.on("value",(snapShot)=>{
          const data= snapShot.val();
          let  list = [];
            for( let id in data)
             {
               list.push({id,...data[id]})
             }
             setArticleWomanSabot(list)
        })
    }

    /***Get Lunettes Articles */
   
      const ReadDataFromDatabaseLunettes = ()=>{
        const articleLunettes = Database.database().ref("Lunettes")
        articleLunettes.on("value",(snapShot)=>{
          const data= snapShot.val();
          let  list = [];
            for( let id in data)
             {
               list.push({id,...data[id]})
             }
             setArticleLunettes(list)
        })
    }


    /******  Create Subscribe   */
    const createSub = (e)=>{
        e.preventDefault();
        const subscribe = Database.database().ref("Abonnées")
        const subscribeEmail = {
            subscribeed
        }
        subscribe.push(subscribeEmail);
        setSubscribeed("")
    }


    return (
        <>
        {loading?(
            <div className="Loading">
                <PuffLoader color={"#E55947"} loading={loading} size={90} />
            </div>  
        ):(
            <>
        <NavBar/>
            <main className="l-main">

                <section className="home" id="home">
                    <div className="home__container bd-grid">
                        <div className="home__data" data-aos="fade-right">
                            <h1 className="home__title">عروض حصرية <br/> <span>تخفيضات تصل إلى %60</span></h1>
                            <a href="#featured" className="button"> GO SHOPPING</a>
                        </div>
                        <img data-aos="fade-up" src={Ban} alt="Bannier__Image" className="home__img"/>
                    </div>
                </section>

                <section className="collection section">
                    <div className="collection__container container bd-grid">
                        <Container>
                            <Row>
                                <Col md={5} lg={5} xs={12} className="collection__box">
                                    <img src={Collection1} alt="Collection" className="collection__img"/>
                                    <div className="collection__data">
                                        <h2 className="collection__title"><span className="collection__subtitle">Women<br/>Back</span></h2>
                                        <a href="#" className="collection__view">View Collection</a>
                                    </div>   
                                </Col> 

                                <Col md={5} lg={5} xs={12} className="collection__box">
                                    <div className="collection__data">
                                        <h2 className="collection__title"><span className="collection__subtitle">Women<br/>Back</span></h2>
                                        <a href="#" className="collection__view">View Collection</a>
                                    </div>   
                                    <img src={Collection2} alt="Collection" className="collection__img"/>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </section>

                <section className="featured section" id="featured">
                    <h2 className="section__title ">المنتجات الأكثر طلباً</h2>
                    <h6 className=" section__title Subtitle">إضغط (ي) على المنتج لمزيد من معلومات حوله</h6>
                    <Container className="featured__container bd_grid">
                        <Row>
                            {articleViral.map((detailsViralP)=>(
                            <Col key={detailsViralP.id} lg={4} md={6} sm={6} xs={4} data-aos="fade-up" className="featured__product">
                                 <Link onClick={()=>setArticleToSend(detailsViralP)} to={`/Confirmation/:${detailsViralP.id}`} className="Cardhover">
                                <div className="cardF">
                                   
                                        <div className="featured__box">
                                            <Badge className="featured__new">Promo</Badge>
                                            <img src={detailsViralP.urlToUse} className="featured__img" alt="Product"/>
                                        </div>
                                    
                                    <div className="featured__data">
                                        <span className="text-center underLine">{`${Math.floor(detailsViralP.prix*1.3)} DH`}</span>        
                                        <span className="featured_preci">
                                            {`${detailsViralP.prix} DH`}
                                        </span>
                                        
                                        <Link className="buttonComanderLink" to="/Confirm_Commande">
                                            <Button onClick={()=>setArticleToSend(detailsViralP)} className="buttonComander buttonComanderLinke text-center" variant="primary">                                             
                                                        Commander
                                            </Button>
                                        </Link> 
                                    </div>
                                </div>
                                </Link>
                            </Col>))}
                        </Row>
                    </Container>
                </section>
                                <section className="offer section">
                                    <div className="offer__bg">
                                        <div className="offer__data">
                                            <h2 className="offer__title">الجديد ديما كيكون عندنا</h2>
                                            <p className="offer__description">
                                            نقدم لكم منتجات بجودة عالية و ثمن في متناول الجميع 
                                            <br/> 
                                            كيما ف تصويرة كيما اوصلك  
                                            </p>
                                        </div>
                                    </div>
                                </section>

                    <section className="new section">
                        <h2 className="section__title">لكي سيدتي</h2>
                        <h6 className=" section__title Subtitle">إضغط (ي) على المنتج لمزيد من معلومات حوله</h6>
                        <Container className="featured__container bd_grid">
                        <Row>
                            {articleWoman.map((articleWomanP)=>(
                            <Col key={articleWomanP.id}  lg={4} md={6} sm={6} xs={4} data-aos="fade-up" className="featured__product">
                                 <Link onClick={()=>setArticleToSend(articleWomanP)} to={`/Confirmation/:${articleWomanP.id}`} className="Cardhover">
                                <div className="cardF">
                                        <div className="featured__box">
                                            <Badge className="featured__new">Promo</Badge>
                                            <img src={articleWomanP.urlToUse} className="featured__img" alt="Product"/>
                                        </div>
                                    <div className="featured__data">
                                        <span className="text-center underLine">{`${Math.floor(articleWomanP.prix*1.3)} DH`}</span>        
                                        <span className="featured_preci">
                                            {`${articleWomanP.prix} DH`}
                                        </span>
                                        
                                        <Link className="buttonComanderLink" to={`/Confirmation/:${articleWomanP.id}`}>
                                            <Button onClick={()=>setArticleToSend(articleWomanP)} className="buttonComander text-center buttonComanderLinke" variant="primary">                                             
                                                        Commander
                                            </Button>
                                        </Link> 
                                    </div>
                                </div>
                                </Link>
                            </Col>))}
                        </Row>
                    </Container>
                        <h2 className="section__title text-center">Sabot</h2>
                        <h6 className=" section__title Subtitle">إضغط (ي) على المنتج لمزيد من معلومات حوله</h6>
                    <Container>
                    <Row>
                              {articleWomanSabot.map((sabot)=>(
                                <Col key={sabot.id} lg={4} md={6} sm={6} xs={4} data-aos="fade-up" className="featured__product">
                                     <Link onClick={()=>setArticleToSend(sabot)} to={`/Confirmation/:${sabot.id}`} className="Cardhover">
                                <div className="cardF">
                                        <div className="featured__box">
                                            <Badge className="featured__new">Promo</Badge>
                                            <img src={sabot.urlToUse} className="featured__img" alt="Product"/>
                                        </div>
                                    <div className="featured__data">
                                        <span className="text-center underLine">{`${Math.floor(sabot.prix*1.3)} DH`}</span>        
                                        <span className="featured_preci">
                                            {`${sabot.prix} DH`}
                                        </span>
                                        
                                        <Link className="buttonComanderLink" to={`/Confirmation/:${sabot.id}`}>
                                            <Button onClick={()=>setArticleToSend(sabot)} className="buttonComander text-center buttonComanderLinke" variant="primary">                                             
                                                        Commander
                                            </Button>
                                        </Link> 
                                    </div>
                                </div>
                                </Link>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                    <Container>
                    <h2 className="section__title text-center">Lunnetes</h2>
                    <h6 className=" section__title Subtitle">إضغط (ي) على المنتج لمزيد من معلومات حوله</h6>
                    <Row>
                              {articleLunettes.map((Glass)=>(
                                <Col key={Glass.id} lg={4} md={6} sm={6} xs={4} data-aos="fade-up" className="featured__product">
                                     <Link onClick={()=>setArticleToSend(Glass)} to={`/Confirmation/:${Glass.id}`} className="Cardhover">
                                <div className="cardF">
                                   
                                    <div className="featured__box">
                                        <Badge className="featured__new">Promo</Badge>
                                        <img src={Glass.urlToUse} className="featured__img" alt="Product"/>
                                    </div>
                                   
                                    
                                    <div className="featured__data">
                                        <span className="text-center underLine">{`${Math.floor(Glass.prix*1.4)} DH`}</span>        
                                        <span className="featured_preci">
                                            {`${Glass.prix} DH`}
                                        </span>
                                        
                                        <Link className="buttonComanderLink" to={`/Confirmation/:${Glass.id}`}>
                                            <Button onClick={()=>setArticleToSend(Glass)} className="buttonComander text-center buttonComanderLinke" variant="primary">                                             
                                                        Commander
                                            </Button>
                                        </Link> 
                                    </div>
                                </div>
                                </Link>
                                </Col>
                            ))}
                        </Row>
                    </Container>

                    </section>
                    <section className="newsletter" id="subscribed">
                        <div className="newsletter__container bd-grid">
                            <div className="newsletter__subscribe">
                                <h2 className="section__title">
                                تسجيل ليصلك كل جديد
                                </h2>
                                <p className="newsletter__description">
                                    تخفيضتنا وعروضنا للفوز بمنتج من اختيارك
                                </p>
                                    <Form className="newsletter__form">
                                        <input type="email"  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2, 4}$"  onChange={(e)=>setSubscribeed(e.target.value)} value={subscribeed} type="text" className="newsletter__input" placeholder="Entre Votre E-mail"/>
                                        <Button onClick={createSub} type="submit" className="button">SUSCRIBE</Button>
                                    </Form>
                            </div>
                        </div>

                    </section>
            </main>
           
                <Footer/>
                </>)}
           
        </>
    )
}

export default Main
